import React, { useState } from "react";

import { updateFarmReviewer } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminUser } from "models";

import { Avatar, ContextMenu, Message as message } from "components";

export const SelectAdminContextMenu = ({
  reviewer,
  adminUsers,
  reviewerId,
  farmId,
}: {
  reviewer: AdminUser | undefined;
  adminUsers: AdminUser[];
  reviewerId: string;
  farmId: string;
}) => {
  const signal = useCancelAsyncOnUnmount()();
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedReviewer, setSelectedReviewer] = useState(reviewer);

  const handleSelectReviewer = (admin: AdminUser) => {
    setLoading(true);
    setShowDropdown(false);
    updateFarmReviewer({
      signal,
      farmId,
      reviewerId: admin.id,
    })
      .then(() => {
        setSelectedReviewer(admin);
        message({
          content: "The gremlins accepted your sacrifice! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      {!loading && (
        <div
          className={"selected-reviewer"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowDropdown(true);
          }}
        >
          <Avatar size={"xs"} name={selectedReviewer ? selectedReviewer.name : " "} />
        </div>
      )}

      <ContextMenu
        items={adminUsers.map((item) => ({
          label: item.name,
          iconName: item.id === reviewerId ? "tabler/circle-check-filled" : "tabler/circle",
          onClick: () => handleSelectReviewer(item),
        }))}
        visible={showDropdown}
        onClose={() => setShowDropdown(false)}
        placement="bottom-left"
        iconPlacement="right"
        iconSize="l"
      />
    </>
  );
};
